import AuthService from './auth-service/authService';
import shopAuthService from './shop-auth-service/shopAuthService';
import UserService from './user-service/userService';
import permissionService from './permission-service/permissionService';

export default {
  AuthService,
  shopAuthService,
  UserService,
  permissionService,
};
